// 游戏盒子最近在玩 客户端存储key
export const PCM_SIDEPANEL_GAMES_RECENT_PLAY_GAMES_LOCAL_DATA =
  "PCM_SIDEPANEL_GAMES_RECENT_PLAY_GAMES_LOCAL_DATA";



// 应用宝小游戏信息
export function getMicroAppGetUserIdentityMark() {
  if (window.pcmjssdk) {
    return window.pcmjssdk.asyncBrowerQuery("NEWPLUGIN_WSPIPEPLUGIN_JS_desktopmainframe_WSPluginHost64.exe", `{\"category\":\"NEWPLUGIN_DESKTOPMAINFRAMEPLUGIN_GETUSERIDENTITYMARK\",\"pluginName\":\"DESKTOPMAINFRAMEPLUGIN.dll\",\"remoteModule\":\"WSPluginHost64.exe\",\"extendmodule\":\"desktopmainframe\",\"timeout\":${Date.now()},\"promoteprivilige\":1,\"pluginpath\":\"D:\\\\ai-stick\\\\desktopmainframe\\\\bin\\\\x64\\\\Debug\\\\DesktopMainFramePlugin.dll\"}`)
  } else if (window.SLBSDK) {
    return window.SLBSDK.nativeCall('GetUserIdentityMark')
  }
}

// 获取应用宝最近在玩
export function getYYBRecentGames() {
    // const message = JSON.stringify(JSON.stringify({
    //   "size": 10,
    //   "open_tab": 2
    // }))
    // return window.pcmjssdk.asyncBrowerQuery('NEWPLUGIN_WSPIPEPLUGIN_JS_desktopmainframe_WSPluginHost64.exe',`{\"category\":\"NEWPLUGIN_DESKTOPMAINFRAMEPLUGIN_GETRECENTOPENORDERLIST\",\"pluginName\":\"DESKTOPMAINFRAMEPLUGIN.dll\",\"message\":${message},\"remoteModule\":\"WSPluginHost64.exe\",\"extendmodule\":\"desktopmainframe\",\"timeout\":${Date.now()},\"promoteprivilige\":1,\"pluginpath\":\"D:\\\\ai-stick\\\\desktopmainframe\\\\bin\\\\x64\\\\Debug\\\\DesktopMainFramePlugin.dll\"}`)
    if (window.pcmjssdk) {
      return window.pcmjssdk.asyncBrowerQuery('NEWPLUGIN_WSPIPEPLUGIN_JS_desktopmainframe_WSPluginHost64.exe',`{\"category\":\"NEWPLUGIN_DESKTOPMAINFRAMEPLUGIN_GETRECENTOPENORDERLIST\",\"pluginName\":\"DESKTOPMAINFRAMEPLUGIN.dll\",\"message\":\"\{\\\"size\\\":10,\\\"open_type\\\":2\}\",\"remoteModule\":\"WSPluginHost64.exe\",\"extendmodule\":\"desktopmainframe\",\"timeout\":${Date.now()},\"promoteprivilige\":1,\"pluginpath\":\"D:\\\\ai-stick\\\\desktopmainframe\\\\bin\\\\x64\\\\Debug\\\\DesktopMainFramePlugin.dll\"}`)
    } else if (window.SLBSDK) {
      return window.SLBSDK?.nativeCall('GetRecentOpenOrderList', [`{"size": 10,"open_type":2}`,])
    }
}

// 开始应用宝小游戏
export async function startYYBGame(data) {
  let gameInfo = {}
  let gameInfoMore = {}
  try {
    const info = await getYYBRecentGames()
    if (info && JSON.parse(info)) {
      const list = JSON.parse(info)
      const gameInfo = list.find(item => item.pkg_name === data.appId)
      if (gameInfo.launch_info_str && JSON.parse(gameInfo.launch_info_str)) {
        gameInfoMore = JSON.parse(gameInfo.launch_info_str)
      }
    }
  } catch (error) {
    console.log(error)
  }
  return new Promise((resove, reject) => {
    if (typeof window?.pcmjssdk?.asyncBrowerQuery !== "function") {
      return reject(false);
    }

    const message = JSON.stringify({
      "applet_click_report_info": gameInfoMore.applet_click_report_info,
      // "applet_click_report_info": {
      //   "appID": data.appId,
      //   "appType": gameInfo.app_type,
      //   "recommendID": gameInfoMore.applet_click_report_info?.recommendID,
      //   "sceneID": gameInfoMore.applet_click_report_info?.sceneID,
      //   "posCard": gameInfoMore.applet_click_report_info?.posCard,
      //   "posInCard": gameInfoMore.applet_click_report_info?.posInCard,
      //   "cardID": gameInfoMore.applet_click_report_info?.cardID,
      //   "request_interface": gameInfoMore.applet_click_report_info?.request_interface,
      //   "clickType": 200,
      //   "operateTime": Date.now()
      // },
      "install_mode": gameInfo.install_mode,
      "pullup_type": gameInfo.pullup_type,
      "app_install_mode": gameInfo.app_install_mode,
      "create_shortcut": gameInfo.create_shortcut,
      "create_app_shortcut": gameInfo.create_app_shortcut,
      "report_info":gameInfo.report_info
    })

    window.pcmjssdk.asyncBrowerQuery('NEWPLUGIN_WSPIPEPLUGIN_JS_desktopmainframe_WSPluginHost64.exe', `{\"category\":\"NEWPLUGIN_DESKTOPMAINFRAMEPLUGIN_LAUNCHAPPLET\",\"pluginName\":\"DESKTOPMAINFRAMEPLUGIN.dll\",\"message\":${JSON.stringify(message)},\"remoteModule\":\"WSPluginHost64.exe\",\"extendmodule\":\"desktopmainframe\",\"timeout\":${Date.now()},\"promoteprivilige\":1,\"pluginpath\":\"D:\\\\ai-stick\\\\desktopmainframe\\\\bin\\\\x64\\\\Debug\\\\DesktopMainFramePlugin.dll\"}`)

  });
}

// 是否支持QQ游戏
export function supportQQGame() {
  return new Promise((resove, reject) => {
    if (typeof window?.pcmjssdk?.asyncBrowerQuery !== "function") {
      return reject(false);
    }
    window?.pcmjssdk
      .asyncBrowerQuery("SupportQQGame")
      .then(() => {
        resove(true);
      })
      .catch(() => {
        reject(false);
      });
  });
}

// 开始微信小游戏
export function startWxGame(data) {
  return new Promise((resove, reject) => {
    if (typeof window?.pcmjssdk?.asyncBrowerQuery !== "function") {
      return reject(false);
    }
    window?.pcmjssdk
      ?.asyncBrowerQuery("WxSmallApp_Start_with", JSON.stringify({
        appid: data.appId,
        name: data.appName,
        icon: data.appIcon,
        type: 1,
      }))
      .then(() => {
        resove(true);
      })
      .catch(() => {
        reject(false);
      });
  });
}

// 开始自研小游戏
export function startADPGame(gameId) {
  return new Promise((resove, reject) => {
    if (typeof window?.pcmjssdk?.asyncBrowerQuery !== "function") {
      return reject(false);
    }
    window?.pcmjssdk
      ?.asyncBrowerQuery("SmallApp_Start", gameId)
      .then(() => {
        resove(true);
      })
      .catch(() => {
        reject(false);
      });
  });
}

// 开始qq游戏

export function startQQGame(gameId) {
  return new Promise((resove, reject) => {
    if (typeof window?.pcmjssdk?.asyncBrowerQuery !== "function") {
      return reject(false);
    }
    window?.pcmjssdk
      ?.asyncBrowerQuery("StartQQGame", gameId)
      .then(() => {
        resove(true);
      })
      .catch(() => {
        reject(false);
      });
  });
}

async function getRegeditUrl() {
  let isChihun = false
  try {
      const oemName = await window.pcmjssdk?.asyncBrowerQuery('GetOEMName')
      console.warn('oemName', oemName)
      isChihun = oemName === 'chihun'
  } catch (error) {
      console.log(error)
  }
  if (isChihun) {
    return 'SOFTWARE\\Blasoul\\PCManager\\DesktopAssist'
  } else {
    return 'SOFTWARE\\Lenovo\\PcManager\\DesktopAssist'
  }
}

// 注册表存储-字符串
export async function setRegedit(name, value) {
  const regeditUrl = await getRegeditUrl()
  return window?.pcmjssdk?.commonMethod.SetCurrentUserRegeditString(
    regeditUrl,
    name,
    value
  );
}

// 注册表读取-字符串
export async function getRegedit(name) {
  const regeditUrl = await getRegeditUrl()
  return window?.pcmjssdk?.commonMethod.GetCurrentUserRegeditString(
    regeditUrl,
    name
  );
}

// 获取用户信息
export function getUserInfo() {
  if (typeof window?.pcmjssdk?.asyncBrowerQuery !== "function") {
    return Promise.resolve({});
  }
  return window.pcmjssdk
    .asyncBrowerQuery("NEWPLUGIN_WRAPPLUGIN_GETLOGININFO")
    .then((res) => {
      if (res) {
        try {
          return JSON.parse(res);
        } catch (e) {
          return res;
        }
      }
    })
    .catch(() => {});
}
